<template>
<div>
  <a-form ref="form">
    <a-form-item :label="$t('message')['DeviceSummary.nickname']" required>
        <a-input id="nickEdt" v-model="formData.nickname" class="edt"></a-input>
    </a-form-item>
    <a-form-item :label="$t('message')['DeviceSummary.gender']" required>
        <a-radio-group
          v-model="formData.gender"
          id="genderOption"
        >
          <a-radio-button :value="1">
            {{ $t('message')['DeviceSummary.male'] }}
          </a-radio-button>
          <a-radio-button :value="2">
            {{ $t('message')['DeviceSummary.female'] }}
          </a-radio-button>
        </a-radio-group>
    </a-form-item>
    <a-form-item :label="$t('message')['DeviceSummary.height']" required>
        <a-input id="height" v-model="formData.height" class="edt"></a-input>cm
    </a-form-item>
    <a-form-item :label="$t('message')['DeviceSummary.weight']" required>
        <a-input id="weight" v-model="formData.weight" class="edt"></a-input>kg
    </a-form-item>
    <a-form-item :label="$t('message')['DeviceSummary.birthday']" required>
        <a-date-picker id="birthDatePicker" v-model="formData.birthday"></a-date-picker>
    </a-form-item>
    <a-form-item :label="$t('message')['DeviceSummary.target.step']" required>
        <a-input-number id="weight" v-model="formData.target_step" :min="3000" :max="30000" step="100"></a-input-number>
    </a-form-item>
    <a-form-item :label="$t('message')['DeviceSummary.target.calorie']" required>
        <a-input-number id="weight" v-model="formData.target_calorie" :min="100" :max="10000" step="10"></a-input-number>kal
    </a-form-item>
    <a-form-item>
        <a-button type="primary" @click="handleSubmit" id="submit">
          {{ $t('message')['DeviceSummary.save'] }}
        </a-button>
        <a-button type="primary" @click="handleCancel">
          {{ $t('message')['DeviceSummary.cancel'] }}
        </a-button>        
    </a-form-item>
  </a-form>
</div>
</template>

<script>
import { notification } from "ant-design-vue";
import domain from "../../domain";
import request from "../../utils/request";
const moment = require('moment');

export default {
  data() {
    return {
      formData: {
        nickname: '',
        gender: 0,
        height: 0,
        weight: 0,
        birthday: '',
        target_step: 0,
        target_calorie: 0
      }
    }
  },
  mounted() {
    this.formData.nickname = this.$route.params.nickname;
    this.formData.gender = this.$route.params.gender;
    this.formData.height = this.$route.params.height;
    this.formData.weight = this.$route.params.weight;
    this.formData.birthday = moment(this.$route.params.birthday);
    this.formData.target_step = this.$route.params.target_step;
    this.formData.target_calorie = this.$route.params.target_calorie;
  },
  methods: {
    handleSubmit() {
      this.formData.nickname = this.formData.nickname.trim();
      if(this.formData.nickname==''){
        this.popError("Warning",this.$t('message')['DeviceSummary.nickname.input']);
        return
      }

      if(this.formData.gender!=1 && this.formData.gender!=2){
        this.popError("Warning",this.$t('message')['DeviceSummary.gender.input']);
        return
      }

      this.formData.height = parseFloat(this.formData.height);
      if(this.formData.height==0){
        this.popError("Warning",this.$t('message')['DeviceSummary.height.input']);
        return
      }

      this.formData.weight = parseFloat(this.formData.weight);
      if(this.formData.weight==0){
        this.popError("Warning",this.$t('message')['DeviceSummary.weight.input']);
        return
      }
      
      console.log('this.formData.birthday:',this.formData.birthday);
      if(this.formData.birthday==''){
        this.popError("Warning",this.$t('message')['DeviceSummary.birthday.input']);
        return
      }

      this.formData.target_step = parseInt(this.formData.target_step);
      if(this.formData.target_step==0){
        this.popError("Warning",this.$t('message')['DeviceSummary.target_step.input']);
        return
      }

      this.formData.target_calorie = parseInt(this.formData.target_calorie);
      if(this.formData.target_calorie==0){
        this.popError("Warning",this.$t('message')['DeviceSummary.target_calorie.input']);
        return
      }

      let deviceid = sessionStorage.getItem("deviceid");      
      let postData = {
        "device_id":deviceid,
        "nickname":this.formData.nickname,
        "gender":this.formData.gender,
        "height":this.formData.height,
        "weight":this.formData.weight,
        "birthday":this.formData.birthday.format('YYYY-MM-DD'),
        "target_step":this.formData.target_step,
        "target_calorie":this.formData.target_calorie
      }

      let that = this;
      let reqUrl = domain.URLS.Update_WearInfo_Url;
      request({
            url: reqUrl,
            method: "POST",
            data: postData
        })
        .then(
        res => {
            if (res.data.ReturnCode == 0) {
              that.popInfo("Info",that.$t('message')['common.save.succeed']);
              that.$router.push({name:"device_summary",params:{
                data_date: that.$route.params.data_date,
                model: that.$route.params.model,
                battery: that.$route.params.battery,
                step: that.$route.params.step
              }});              
            }
            else{
              that.popError("Error",that.$t('message')['common.save.failed']);
            }
        },
        function() {}
        );
    },
    handleCancel() {
      this.$router.push({name:"device_summary",params:{
          data_date: this.$route.params.data_date,
          model: this.$route.params.model,
          battery: this.$route.params.battery,
          step: this.$route.params.step
      }});
    },
    popError(title, desc) {
      notification.error({
        // eslint-disable-next-line no-unused-vars
        message: h => (
          <div>
            <span style="color: red">{title}</span>
          </div>
        ),
        description: desc
        });
    },
    popInfo(title, desc) {
      notification.info({
        // eslint-disable-next-line no-unused-vars
        message: h => (
          <div>
            <span style="color: green">{title}</span>
          </div>
        ),
        description: desc
        });
    }    
  }
}
</script>

<style scoped>
#submit{
  margin-right: 30px;
}

.edt{
  width: 300px;
}
</style>